// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dzw8","type":"styles_type__2vGLI","choices":"styles_choices__2dMVB"};